import * as API from '@/api';

export const actions = {
  // R: 取得旅遊文章列表
  async getThemes({ commit }, data) {
    const params = {
      ...data,
      limit: 6
    }
    const list = await API.GET('/themes', params)

    // 濾掉下架的文章
    list.data.data = list.data.data.filter(theme => theme.is_on === 1);

    commit('setThemes', list.data);
  },

  // R: 取得一篇旅遊文章
  async getTheme({ commit }, articleId) {
    const theme = await API.GET(`/themes/${articleId}`);
    const customizedTheme = { ...theme.data };

    if (!theme.data.tags) {
      customizedTheme.tags = [];
    }

    customizedTheme.links = theme.data.links.filter((link) => link.name && link.url);

    customizedTheme.related_sights = theme.data.related_sights.map((temple) => {
      const customizedRelatedTemple = JSON.parse(JSON.stringify(temple));
      customizedRelatedTemple.id = parseInt(customizedRelatedTemple.reference, 10);

      return customizedRelatedTemple;
    });

    commit('setTheme', customizedTheme);
  },
};
